import { createFileRoute } from '@tanstack/react-router';

import { StudentMakeupsPage } from '~features/students/ui/student-makeups-page';

const Component = () => {
  const { studentId } = Route.useParams();
  return <StudentMakeupsPage studentId={studentId} />;
};

export const Route = createFileRoute(
  '/_auth/_layout/students/$studentId/makeups',
)({
  component: Component,
});
